import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../../../CloudStorage/LoadCSSforfirstTime";
import { useParams } from "react-router-dom";
import {
  getPostsById,
  getPostsCancelById,
} from "../../../../../../../redux/posts/action";
import { useDispatch, useSelector } from "react-redux";
import MineContestOverview from "./MineContestOverview";
import CommonContestEntries from "../../../../../FindWork/SearchContestParticipate/ContestDetails/CommonContestEntries";
import MineContestHandover from "./MineContestHandover";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import CustomConfetti from "../../../../../../Common/CongrulationsPopup/CustomConfetti";
import { useRouteBaseStateContext } from "../../../../../../../Context/RouteBaseStateContext";
import pdficon from "../../../../../../Common/FilesRelevent/pdf.png";
import CustomRating from "../../../../../../Common/CustomeLabel/CustomRating";
import Won from "../../../../../../Common/CongrulationsPopup/Won";
import HelpSupportModal from "../../../../../../Common/HelpSupport/HelpSupportModal";
import ProfilePic from "../../../../../../../assests/imgs/Profileplaceholder.svg";

export default function MineContestDetailsTabs() {
  const { id } = useParams();
  const path = "Assets/scss/searchcontestparticipate.module.scss";
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("ContestOverview"); // State to track active tab
  const [pd, setPd] = useState(null);
  const { urlstate, setManageActivecontestroute } = useRouteBaseStateContext();
  const posts = useSelector(({ posts: { postbyid } }) => postbyid);
  const [theModal, setTheModal] = useState(false);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (posts?.proposal && posts.proposal.length > 0) {
      const selectedProposal = posts.proposal.find((item) => item?.status > 11);
      setPd(selectedProposal || null);
    } else {
      setPd(null);
    }
  }, [posts]);

  useEffect(() => {
    if (urlstate?.manageactivecontestroute) {
      setActiveTab(urlstate?.manageactivecontestroute || "ContestOverview");
    } else {
      setActiveTab("ContestOverview");
    }
  }, [urlstate, urlstate?.manageactivecontestroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setManageActivecontestroute(tab);
  };

  const getHeader = () => {
    if (posts.is_mine == 1 && pd.is_mine != 1) {
      // Owner
      switch (pd?.status) {
        case 11:
          return "Waiting for Submission";
        case 12:
          return "Winner has been chosen. Waiting for Submission";
        case 13:
          return "Review the Submitted Documents";
        case 14:
          return "Documents Rejected";
        case 15:
          return "Submission Accepted - Congratulations 🎉🎉🎉";
        default:
          return "Unknown Status";
      }
    }

    if (posts.is_mine != 1 && pd.is_mine == 1) {
      switch (pd?.status) {
        case 11:
          return "Submit Required Documents";
        case 12:
          return "Congratulations 🎉🎉🎉, You Won, Upload Documents";
        case 13:
          return "Awaiting Review of Submitted Documents";
        case 14:
          return "Documents Rejected: Please Resubmit";
        case 15:
          return "Congratulations 🎉🎉🎉";
        default:
          return "Unknown Status";
      }
    } else {
      return "Winner Has Been Chosen";
    }
  };

  const getMessage = () => {
    if (posts.is_mine == 1 && pd.is_mine != 1) {
      // Owner
      switch (pd?.status) {
        case 11:
          return "Thank you for participating in the contest. We are currently awaiting your submission. Please make sure to submit your entry before the deadline to ensure it is reviewed on time.";
        case 12:
          return "waiting for submission documents, Please be active to review the submitted entry to ensure everything is in order.";
        case 13:
          return "Please examine the submitted documents carefully. If any adjustments are needed, kindly address them promptly. We appreciate your attention to detail.";
        case 14:
          return "The submitted document did not meet the criteria. The expert is expected to resubmit shortly. The expert has been notified to revise their submission. Thank you for your understanding; we will update you as soon as we receive the new document.";
        case 15:
          return "Congratulations! The submission has been accepted, and the contest winner has been confirmed. The necessary documentation is complete, and the prize money is secured. The exceptional entry has earned this achievement. We’re excited to celebrate this success!";
        default:
          return "There appears to be an issue with the status. Please contact support for further assistance.";
      }
    }

    if (posts.is_mine != 1 && pd.is_mine == 1) {
      // Expert
      switch (pd?.status) {
        case 11:
          return "We are currently awaiting the necessary documents from you. Please submit all required documentation to proceed with the review process.";
        case 12:
          return "To proceed with the review and next steps, please upload your documents. They will be thoroughly examined to ensure all requirements are met. Thank you for your cooperation.";
        case 13:
          return "Your documents are currently being reviewed. We will update you once the evaluation is complete. Thank you for your patience.";
        case 14:
          return "We regret to inform you that the documents you submitted have not been approved. Please review the feedback provided and resubmit the necessary documents at your earliest convenience. Ensure that all required information is included and meets the specified guidelines. If you have any questions or need further assistance, feel free to contact.";
        case 15:
          return "Fantastic news! Your submission has been accepted, and you are the contest winner. Your diligence and effort have paid off, and we are excited to congratulate you on your well-deserved success!";
        default:
          return "It seems there is an issue with the status. Please contact our support team for further clarification and assistance.";
      }
    }

    return "The contest winner has been chosen. Thank you for participating, and we wish you the best of luck in future contests. Stay tuned for more opportunities!";
  };

  const getButton = () => {
    const commonButtonStyle = { color: "#fff", background: "orange" };

    if (posts.is_mine == 1 && pd.is_mine != 1) {
      // Owner
      if (pd?.status == 15) {
        return null;
      }

      const buttonTitles = {
        11: "View Submission Details",
        12: "View Submission Details",
        13: "Review Submission",
        14: "View Submission Details",
      };

      if (pd?.status in buttonTitles) {
        return (
          <button
            style={commonButtonStyle}
            onClick={() => handleTabClick("Handover")}
            className ="btn"
          >
            {buttonTitles[pd?.status]}
          </button>
        );
      }
    } else if (posts.is_mine != 1 && pd.is_mine == 1) {
      // Expert
      const buttonTitles = {
        11: "Submit Required Documents",
        12: "Submit Required Documents",
        13: "View Submission",
        14: "Re-submit Required Documents",
      };

      if (pd?.status in buttonTitles) {
        return (
          <button
            style={commonButtonStyle}
            onClick={() => handleTabClick("Handover")}
            className ="btn"
          >
            {buttonTitles[pd?.status]}
          </button>
        );
      }
    }

    return null;
  };

  const handleImageError = (e) => {
    e.target.src = pdficon;
  };

  const isblastviewd = () => {
    return posts?.rewarded_on > posts?.last_viewed_on;
  };

  const cancelpost = () => {
    const data = {
      post_id: posts?.id,
      type: "2",
      status: "14",
    };
    dispatch(getPostsCancelById(data));
  };

  return (
    <div className ="project-section">
      <div
        style={{
          display: "flex",
          alignItems:'center',
          justifyContent: "space-between",
        }}
      >
        <h4>{posts?.title}</h4>
        <button className ="background-button btn" onClick={() => setTheModal(true)}>
          Dispute
        </button>
      </div>
      {pd &&
        (pd?.status == 12 ||
          pd?.status == 13 ||
          pd?.status == 14 ||
          pd?.status == 15) && (
          <div className ="entries">
            {isblastviewd() == true ? (
              <>
                <CustomConfetti />{" "}
              </>
            ) : (
              ""
            )}
            {posts.is_mine == 1 ? (
              ""
            ) : pd.is_mine == 1 && isblastviewd() == true ? (
              <>
                <Won />
              </>
            ) : (
              ""
            )}
            <div className ="entries-second">
              <div className ="row align-items-center">
                <div className ="col-md-7">
                  <div className ="entry-background">
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/handover/winnertag.svg`}
                      className ="winner-tag"
                      alt=""
                    />
                    <div className ="row entrysecond-row">
                      <div className ="col-md-5 entry-left">
                        <img
                          src={Array.isArray(pd?.files) && pd?.files[0]?.file}
                          className ="w-100"
                          alt="Entry"
                          onError={handleImageError}
                        />
                      </div>
                      <div className ="col-md-7 entry-right">
                        <div className ="entry-label">
                          <img
                            width={30}
                            src={pd?.profile_image ? pd?.profile_image :ProfilePic}
                            className ="label-img"
                            alt="Profile"
                          />
                          <div>
                            <p>
                              <span>
                                {pd?.first_name} {pd?.last_name}
                              </span>
                            </p>
                            <h6>Entry no. : #{pd?.entry_number}</h6>
                          </div>
                        </div>
                        <CustomRating
                          rating={pd?.rating+1}
                          posts={posts}
                          values={pd}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className ="col-md-5 winner-right">
                  {getHeader() && <h6>{getHeader()}</h6>}
                  {getMessage() && <p>{getMessage()}</p>}
                  {pd.is_mine == 1 || posts.is_mine == 1 ? (
                    <>{getButton()}</>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      <div className ="col-12">
        <ul className ="nav nav-tabs">
          <li className ="nav-item">
            <a
              className ={`nav-link ${
                activeTab == "ContestOverview" ? "active" : ""
              }`}
              onClick={() => handleTabClick("ContestOverview")}
            >
              WBO Overview
            </a>
          </li>
          <li className ="nav-item">
            <a
              className ={`nav-link ${activeTab == "Entries" ? "active" : ""}`}
              onClick={() => handleTabClick("Entries")}
            >
              Entries ({posts?.proposal_count})
            </a>
          </li>
          {pd &&
            (pd.is_mine == 1 || posts.is_mine == 1) &&
            (pd?.status == 12 ||
              pd?.status == 13 ||
              pd?.status == 14 ||
              pd?.status == 15) && (
              <li className ="nav-item">
                <a
                  className ={`nav-link ${
                    activeTab == "Handover" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("Handover")}
                >
                  Handover
                </a>
              </li>
            )}
        </ul>
        <div className ="tab-content">
          <div
            className ={`tab-pane ${
              activeTab == "ContestOverview" ? "active" : ""
            }`}
            id="ContestOverview"
          >
            <MineContestOverview pd={pd} posts={posts} cancelpost={cancelpost} />
          </div>
          <div
            className ={`tab-pane ${activeTab == "Entries" ? "active" : ""}`}
            id="Entries"
          >
            <CommonContestEntries posts={posts} pd={pd} />
          </div>
          {pd &&
            (pd.is_mine == 1 || posts.is_mine == 1) &&
            (pd?.status == 12 ||
              pd?.status == 13 ||
              pd?.status == 14 ||
              pd?.status == 15) && (
              <div
                className ={`tab-pane ${
                  activeTab == "Handover" ? "active" : ""
                }`}
                id="Handover"
              >
                <MineContestHandover posts={posts} pd={pd} />
              </div>
            )}
        </div>
        <HelpSupportModal
          theModal={theModal}
          setTheModal={setTheModal}
          data={posts}
          masterID={id}
          masterType="7"
        />
      </div>
    </div>
  );
}
